module.exports = __webpack_public_path__ + "static/media/edsiderlogo.d07932a8.png";